<template>
    <md-table-head class="index-table-head" :class="classes" @click.native="changeSortableState">
        <slot/>
        <div v-if="showAsc" class="icon-container">
            <md-icon>arrow_drop_down</md-icon>
        </div>
        <div v-if="showDesc" class="icon-container">
            <md-icon>arrow_drop_up</md-icon>
        </div>
    </md-table-head>
</template>

<script>
    import {mapGetters, mapMutations} from "vuex";

    export default {
        name: "IndexTableHead",
        props: {
            slug: {
                type: String,
                required: true,
            },
            sortable: {
                type: Boolean,
                default: true,
            }
        },
        computed: {
            sortableState() {
                return this.sort[this.slug] ?? null;
            },
            showAsc() {
                return this.sortableState === 'asc';
            },
            showDesc() {
                return this.sortableState === 'desc';
            },
            classes() {
                return {
                    'sortable': this.sortable,
                };
            },
            ...mapGetters('indexTable', {
                sort: 'getSort',
            })
        },
        methods: {
            changeSortableState() {
                if (this.sortable) {
                    switch (this.sortableState) {
                        case null:
                            this.setSort({column: this.slug, value: 'asc'});
                            break;
                        case 'asc':
                            this.setSort({column: this.slug, value: 'desc'});
                            break;
                        case 'desc':
                            this.setSort({column: this.slug, value: null});
                            break;
                    }
                }
            },
            ...mapMutations('indexTable', {
                setSort: 'setSort',
            })
        }
    }
</script>

<style lang="scss">
    .index-table-head {
        user-select: none;
        background-color: #fff;

        .md-table-head-label {
            padding: 0 !important;
            text-align: center;
            font-size: 1em !important;
        }

        &.sortable:hover {
            background-color: #f1f1f1;
            cursor: pointer;
        }

        .icon-container {
            float: right;
            display: flex;
            align-items: center;
            width: 24px;
            height: 100%;
        }
    }
</style>